@if (loading) {
  <div class="loader"></div>
}

@if (view == 'filter-catering') {
  <app-filter-catering
    [filterArguments]="filterArguments"
    [currentProject]="currentProject"
    [lists]="formLists"
    [loading]="loadingFilters"
    (closeView)="changeView('home')"
    (notify)="filter($event)">
  </app-filter-catering>
}

@if (view == 'add-purchase') {
  <app-add-purchase-order
    [element]="selectedItem"
    [type]="'catering'"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-purchase-order>
}

@if (view == 'add-invoice') {
  <app-add-service-invoice
    [element]="selectedItem"
    [type]="'catering'"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-service-invoice>
}

@if (view == 'detail-service') {
  <app-catering-detail-files
    [catering]="selectedItem"
    [project]="currentProject"
    [showProject]="!currentProject"
    [isShooting]="isRequirementsPage"
    (closeView)="changeView('home')"
    (notify)="loadData()"
    (onStatusChange)="onCateringStatusChange()">
  </app-catering-detail-files>
}

@if (view == 'edit-catering') {
  <app-add-catering
    [lists]="formLists"
    [types]="formLists.catering_types"
    [catering]="selectedItem"
    [projectId]="project_id"
    [hasShooting]="selectedItem?.shooting_schedule_id ? true : false"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-catering>
}

@if (view == 'add-catering') {
  <app-add-catering
    [lists]="formLists"
    [types]="formLists.catering_types"
    [hasShooting]="false"
    [projectId]="project_id"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-catering>
}

@if (view == 'add-file-cat') {
  <app-add-file-service
    [service]="selectedItem"
    [type]="'catering'"
    [projectId]="currentProject?.id || selectedItem?.project_id"
    [cateringList]="cateringFileLists"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-add-file-service>
}

@if (view == 'Delete-catering') {
  <app-delete-catering
    [catering]="selectedItem"
    (closeView)="changeView('home')"
    (notify)="loadData()">
  </app-delete-catering>
}

@if (view == 'confirm-new') {
  <app-confirm-window
    [title]="'Mark as new'"
    [subtitle]="'Are you sure you want to mark this catering as new?'"
    (closeView)="changeView('home')"
    (confirm)="changeView('home'); changeStatus(1)">
  </app-confirm-window>
}

@if (view == 'order-table') {
  <app-order-table
    [orderItems]="headers"
    [minNumber]="3"
    (closeView)="changeView('home')"
    (notify)="orderHeaders($event)">
  </app-order-table>
}

@if (view == 'view-history') {
  <app-view-service-catering-history
    [item]="selectedItem"
    [type]="'catering'"
    (closeView)="changeView('home')">
  </app-view-service-catering-history>
}

<div class="main-wrapper">

  @if (selectedItem && _gS.showContext) {
    <div class="contextmenuConteiner" (click)="_gS.hidemenu()"  (contextmenu)="_gS.hidemenu()">
      <div class="contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy">
        <ul>
          <li (click)="changeView('detail-service')">{{'View detail' | translate}}</li>
          <li (click)="changeView('view-history')">{{'View history' | translate}}</li>
          <!-- Options finance page -->
          @if ((_gS.validateAcces({id:47, type:'write'}) || _gS.validateAcces({id:31, type:'write'})) && !isRequirementsPage) {
            <li (click)="changeViewAndGetFilters('edit-catering')">{{'Edit' | translate}}</li>
            <!-- Options always available to access "Legalize Invoice" -->
            @if (_gS.validateAcces({id:47, type:'write'}) || selectedItem.service_statuses_id == SERVICE_STATUS.Submitted|| selectedItem.service_statuses_id == 2 || selectedItem.service_statuses_id == 3 || selectedItem.service_statuses_id == 4) {
              <li (click)="changeView('confirm-new')">{{'Mark as new' | translate}}</li>
            }
            @if (_gS.validateAcces({id:47, type:'write'}) || selectedItem.service_statuses_id == SERVICE_STATUS.Submitted|| selectedItem.service_statuses_id == 1 || selectedItem.service_statuses_id == 4) {
              <li (click)="changeStatus(2)">{{'Mark as pending' | translate}}</li>
            }
            @if (_gS.validateAcces({id:47, type:'write'}) || selectedItem.service_statuses_id == SERVICE_STATUS.Submitted|| selectedItem.service_statuses_id == 1 || selectedItem.service_statuses_id == 2 || selectedItem.service_statuses_id == 3) {
              <li (click)="changeStatus(4)">{{'Mark on process' | translate}}</li>
            }
            @if (_gS.validateAcces({id:47, type:'write'}) || selectedItem.service_statuses_id == SERVICE_STATUS.Submitted|| selectedItem.service_statuses_id == 2 || selectedItem.service_statuses_id == 3 || selectedItem.service_statuses_id == 4) {
              <li (click)="changeStatus(5)">{{'Mark on purchase order' | translate}}</li>
            }
            <li (click)="changeView('add-purchase')">{{(selectedItem.po ? 'Edit purchase order' : 'add purchase order') | translate}}</li>
            <li (click)="changeView('add-invoice')">{{(selectedItem.invoice ? 'Edit invoice' :'add invoice') | translate}}</li>
            @if (_gS.validateAcces({id:47, type:'write'})) {
              <li (click)="filterFileCateringList()">{{'Add files' | translate}}</li>
            }
          }
          <!-- Options requirements page -->
          @if (_gS.validateAcces({id:19, type:'write'}) && isRequirementsPage && canEditCatering(selectedItem)) {
            <li (click)="changeViewAndGetFilters('edit-catering')">{{'Edit' | translate}}</li>
            @if (selectedItem.service_statuses_id == 1 && _gS.validateAcces({id:44, type:'write'})) {
              <li (click)="changeStatus(7)">{{'$submit' | translate}}</li>
            }
            <li (click)="filterFileCateringList()">{{'Add files' | translate}}</li>
            <li (click)="changeView('Delete-catering')">{{'Delete catering' | translate}}</li>
          }
        </ul>
      </div>
    </div>
  }

  @if (!loading) {
    <div class="header">
      <div class="breadcrump">
        <ul>
          <li [routerLink]="['/home']">{{'Home' | translate}}</li>
          @if (isRequirementsPage) {
            <li [routerLink]="['/projects']">{{'Projects' | translate}}</li>
            <li [routerLink]="['/projects', currentProject.id]">{{currentProject.title}}</li>
            <li [routerLink]="['/projects', currentProject.id, 'requirements']">{{'Requirements' | translate}}</li>
          }
          @if (!isRequirementsPage) {
            @if (currentProject) {
              <li [routerLink]="['/projects']">{{'Projects' | translate}}</li>
              <li [routerLink]="['/projects', currentProject.id]">{{currentProject.title}}</li>
              <li [routerLink]="['/projects', currentProject.id, 'finance']">{{'Finance' | translate}}</li>
            } @else {
              <li [routerLink]="['/finance']">{{'Finance' | translate}}</li>
            }
          }
        </ul>
      </div>
      <div class="page-tittle">
        <h1>{{'Caterings' | translate}}</h1>
        <div class="buttons">
          <a (click)="goBack()">{{'Go back' | translate}}</a>
          @if (isRequirementsPage) {
            <a (click)="changeViewAndGetFilters('add-catering')">{{'Add' | translate}}</a>
          }
          <a (click)="changeViewAndGetFilters('filter-catering')">{{'Filter' | translate}}</a>
          <a (click)="exportResponse()">{{'Export' | translate}}</a>
          @if (caterings?.length) {
            <a (click)="changeView('order-table')">{{'Order table' | translate}}</a>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="L-12 M-12 S-12 columns">
        <div class="XL-2 L-3 M-3 S-4 columns search-wrapper">
          <input type="text" class="search" placeholder="{{'Search' | translate}}" [(ngModel)]="filterArguments.search_text" name="search_text" (blur)="filter()">
        </div>
        <div class="XL-10 L-9 M-9 S-8 columns">
          <div class="Scrollble AlignRight">
            <app-box-graph
              [value]="totalCateringsFiltered"
              [label]="'Total' | translate"
              [type]="'currency'"
              [autowidth]="true">
            </app-box-graph>
          </div>
        </div>
      </div>
    </div>
    <div class="row filterArguments">
      @for (argu of filterArguments.projects; track argu; let i = $index) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Project' | translate}}: {{argu.title}}
          <span (click)="removeFromArgumentArray(filterArguments.projects,i)">X</span>
        </div>
      }
      @if (filterArguments.date_from) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Date from' | translate}}: {{filterArguments.date_from | date: 'MMM-dd-yyyy'}}
          <span (click)="removeFilter('date_from')">X</span>
        </div>
      }
      @if (filterArguments.date_to) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Date to' | translate}}: {{filterArguments.date_to | date: 'MMM-dd-yyyy'}}
          <span (click)="removeFilter('date_to')">X</span>
        </div>
      }
      @for (argu of filterArguments.units; track argu; let i = $index) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Unit' | translate}}:  {{argu.unit_name}}
          <span (click)="removeFromArgumentArray(filterArguments.units,i)">X</span>
        </div>
      }
      @for (argu of filterArguments.status; track argu; let i = $index) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Status' | translate}}: {{_gS.backTranslate(argu, 'se_st_name')}}
          {{ argu.isExcluded ? '(' + ('Without' | translate) + ')' : '' }}
          <span (click)="removeFromArgumentArray(filterArguments.status,i)">X</span>
        </div>
      }
      @for (argu of filterArguments.type; track argu; let i = $index) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Type' | translate}}: {{_gS.backTranslate(argu, 'catering_name')}}
          {{ argu.isExcluded ? '(' + ('Without' | translate) + ')' : '' }}
          <span (click)="removeFromArgumentArray(filterArguments.type,i)">X</span>
        </div>
      }
      @for (argu of filterArguments.po; track argu; let i = $index) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Purchase order' | translate}}: {{argu.po}}
          {{ argu.isExcluded ? '(' + ('Without' | translate) + ')' : '' }}
          <span (click)="removeFromArgumentArray(filterArguments.po,i)">X</span>
        </div>
      }
      @if (filterArguments.search_text) {
        <div class="L-2 M-3 S-4 columns argument">
          {{'Text' | translate}}: {{filterArguments.search_text}}
          <span (click)="removeFilter('search_text')">X</span>
        </div>
      }
    </div>
    <div class="row wrapper-content">
      @if (!filteredCaterings.length) {
        <div class="noDataToShow">
          {{'There are no results to show' | translate}}
        </div>
      }
      @if (filteredCaterings.length) {
        <app-table
          [headers]="headers"
          [list]="filteredCaterings"
          [pagination]="true"
          [height100]="true"
          [noMargin]="true"
          [showMobileMenu]="true"
          [paginationOptions]="paginationOptions"
          [backendPaginationOptions]="backendPaginationOptions"
          (notifyOrderTable)="cangeOrder($event)"
          (contextClick)="contextItem($event)"
          (onChangePagination)="changePagination($event, paginationOptions)">
        </app-table>
      }
    </div>
  }
</div>